var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mentoring-activity-list"},_vm._l((_vm.items),function(item,i){return _c(_vm.getCardComponent(item),{key:item.id,tag:"component",class:[_vm.getCardComponent(item)],attrs:{"item":item},on:{"click":function($event){return _vm.$emit('click', { index: i, event_type: $event })}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }